module.exports = __webpack_public_path__ + "img/tpc-25.72b7e070.jpg";